export function benchmarkIsActive(value: unknown): boolean {
  return value === true || value === 1 || value === '1';
}

export function benchmarkIncludedInWeightedWork(benchmark: any): boolean {
  return Number(benchmark?.brand_type_id) === 1 && benchmarkIsActive(benchmark?.is_active) && Number(benchmark?.unit_time_duration_ms) > 0;
}

/** Optional on historical snapshots; their captured results are not recalculated. */
export interface StaffBenchmarkPolicy {
  benchmark_policy?: 'active_only';
}

export const STAFF_ACTIVE_BENCHMARKS_UPDATE_MESSAGE = 'Active benchmark settings require the updated reporting API. Upload the local development reporting files and refresh.';
